import Product from "../../slices/product_management/product/Product"
import Pricing from "../../slices/product_management/pricing/Pricing"
import Review from "../../slices/product_management/review/Review"
import Recipe from "../../slices/product_management/recipe/Recipe"

const productManagementReducer = {
    product: Product,
    pricing: Pricing,
    review: Review,
    recipe: Recipe,
};

export default productManagementReducer;